module.exports = __webpack_public_path__ + "static/images/ede5a889ca1fa741a3186b41a40ff52c.png";